import * as React from "react";
import {BookingInfo} from "../../../../js/api/bookings/BookingInfo";
import moment from 'moment';
import {Card, Dropdown, Icon, Menu, Popconfirm, Tooltip} from "antd";

interface Props {
    request: BookingInfo,
    onAccept: (bookingId: number, sendEmail: boolean) => void,
    onReject: (bookingId: number, sendEmail: boolean) => void,
}

export class BookingRequestCard extends React.Component<Props> {

    private AcceptAction(){
        const { request, onAccept } = this.props;
        const menu = (
            <Menu>
                <Menu.Item onClick={() => onAccept(request.id, false)}>
                    Accept Request
                </Menu.Item>
                <Menu.Item onClick={() => onAccept(request.id, true)}>
                    Accept & Send Auto-generated Email
                </Menu.Item>
            </Menu>
        );
        return(
            <Dropdown overlay={menu} trigger={['click']} placement="bottomCenter">
                <Tooltip placement="top" title="Accept Request">
                    <Icon type="check" />
                </Tooltip>
            </Dropdown>)
    };

    private DeleteAction() {
        const { request, onReject } = this.props;
        const menu = (
            <Menu>
                <Menu.Item onClick={() => onReject(request.id, false)}>
                    Reject Request
                </Menu.Item>
                <Menu.Item onClick={() => onReject(request.id, true)}>
                    Reject & Send Auto-generated Email
                </Menu.Item>
            </Menu>
        );
        return(
            <Dropdown overlay={menu} trigger={['click']} placement="bottomCenter">
                <Tooltip placement="top" title="Reject Request">
                    <Icon type="close" />
                </Tooltip>
            </Dropdown>)
    };

    private EmailAction(): JSX.Element{
        const { request } = this.props;
        const subject: string = `Regarding your booking request at Riad Remmy`;
        const body: string = `Hello ${request.guest.name},\n` +
                        `Regarding your booking request at Riad Remmy between `
                        + `${moment(request.details.checkIn).format("Do MMMM YYYY")} and `
                        + `${moment(request.details.checkOut).format("Do MMMM YYYY")}.\n`;
        return(
            <Tooltip placement="top" title="Email Guest">
                <a href={`mailto:${request.guest.email}?subject=${escape(subject)}&body=${escape(body)}`}>
                    <Icon type="mail" />
                </a>
            </Tooltip>)
    };

    render() {
        const {request} = this.props;
        const numNights = moment(request.details.checkOut).diff(moment(request.details.checkIn), 'days');
        const totalCost = numNights * request.details.bookingRooms
            .map(r => r.roomRate)
            .reduce((a, b) => a + b, 0);
        return(
            <Card
                style={{ maxWidth: 500, margin: "auto", marginBottom: 50}}
                actions={[this.AcceptAction(), this.DeleteAction(), this.EmailAction()]}
            >
                <div className={"br_content"}>
                    <p className={"box_in"}>
                        <span className={"id_text"}>#{request.id}</span>
                    </p>
                    <div className={"box_in"}>
                        <table className={"even_spaced_table br_info_tbl"}>
                            <thead>
                            <tr>
                                <td>
                                    <b>Name</b>
                                </td>
                                <td>
                                    <b>Email</b>
                                </td>
                                <td>
                                    <b>Phone</b>
                                </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    {request.guest.name}
                                </td>
                                <td>
                                    {request.guest.email}
                                </td>
                                <td>
                                    {request.guest.phone}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className={"box_in"}>
                        <table className={"even_spaced_table br_info_tbl"}>
                            <thead>
                            <tr>
                                <td>
                                    <b>ARRIVAL</b>
                                </td>
                                <td>
                                    <b>DEPARTURE</b>
                                </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    {moment(request.details.checkIn).format('DD/MM/YYYY')}
                                </td>
                                <td>
                                    {moment(request.details.checkOut).format('DD/MM/YYYY')}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className={"box_in"}>
                        <table className={"even_spaced_table br_info_tbl"}>
                            <thead>
                            <tr>
                                <td>
                                    <b>NIGHTS</b>
                                </td>
                                <td>
                                    <b>GUESTS</b>
                                </td>
                                <td>
                                    <b>ROOMS</b>
                                </td>
                                <td>
                                    <b>COST</b>
                                </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    {numNights}
                                </td>
                                <td>
                                    {request.details.numGuests}
                                </td>
                                <td>
                                    {request.details.bookingRooms.map(r => "Room " + r.roomId).join(", ")}
                                </td>
                                <td>
                                    {request.details.currency + totalCost}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className={"box_in"}>
                        <table className={"even_spaced_table br_info_tbl"}>
                            <thead>
                                <tr>
                                    <td>
                                        <b>Requests/Enquiries</b>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {request.details.requests}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Card>);
    }
}
